export enum Store {
  USERSECRETKEY = 'bms-key-v001',
}

export enum ROLE {
  Manager = 'Manager',
  RootAdmin = 'Root Admin',
  ICT = 'ICT',
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Staff = 'Staff',
  HOD = 'HOD',
  BudgetDeskOfficer = 'Budget Desk Officer',
  BudgetOfficer = 'Budget Officer',
  SPRD = 'SPRD',
  Auditor = 'Auditor',
  // Finance_Treasury = 'Finance/Treasury',
  Finance_Treasury = 'Treasury',
  ES = 'ES',
  DFA = 'DFA',
  // Director = 'Director',
  Head_Of_Budget = 'Head of Budget',
  DSPR = 'DSPR',
  HR = 'HR',
  ZonalCoordinator = 'Zonal Coordinator',
  HAO = 'HAO',
}
